<template>
    <div>
        <ts-loading-banner :loading="loading">
            <form class="form-horizontal">
                <div class="row form-group">
                    <label class="col-form-label col-md-2 required">{{
                        $t('studentGalleryBK.eventDate')
                    }}</label>
                    <div class="col-md-10">
                        <ts-date-picker-input v-model="model.event_date">
                        </ts-date-picker-input>
                        <div class="invalid-feedback" v-if="errors.has('event_date')">
                            {{ errors.first('event_date') }}
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-2 required">{{
                        $t('studentGalleryBK.eventName')
                    }}</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control" v-model="model.event_name"
                            :class="{ 'is-invalid': errors.has('event_name') }" />
                        <div class="invalid-feedback" v-if="errors.has('event_name')">
                            {{ errors.first('event_name') }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <ts-button class="mr-2" @click="clearInput">{{
                            $t('cancel')
                        }}</ts-button>
                        <ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">
                            {{ $t("update") }}</ts-button>
                    </div>
                </div>
            </form>
        </ts-loading-banner>
    </div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState } from 'vuex'
import { isEmpty } from "lodash";
export default {
    name: 'edit',
    data() {
        return {
            loading: false,
            waiting: false,
            errors: new Errors(),
            model: {
                upload_id: 0,
                event_date: moment().format('DD-MM-YYYY'),
                event_name: null,
            }
        }
    },
    created() {
        this.setEditData()
    },
    computed: {
        ...mapState("staffStudentGalleryBk", ["edit_data"]),
    },
    methods: {
        onUpdate() {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('staffStudentGalleryBk/update', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.clearInput()
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model.upload_id = this.edit_data.upload_id
                this.model.event_name = this.edit_data.event_name
                this.model.event_date = moment(this.edit_data.event_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            }
        },
        clearInput() {
            this.$emit('close')
            this.errors = new Errors()
            this.model.upload_id = 0
            this.model.event_name = null
            this.model.event_date = moment().format('DD-MM-YYYY')
        }
    }
}
</script>
  